export default __webpack_public_path__ + "static/media/350496__tris6970__plastic-tile.ba3e7373.mp3";